/**
 *
 * Dashboard
 *
 */

import { mapState, mapGetters, mapActions } from 'vuex';
import $ from 'jquery';

const GetReopenInfoMixin = {
  name: 'GetReopenInfoMixin',

  computed: {
    ...mapGetters({
      mg_userInfo: 'userInfo',
    }),

    c_isLogin() {
      return Boolean(this.mg_userInfo.studentId);
    },
  },

  methods: {
    ...mapActions('Dashboard', {
      ma_getReopenInfo: 'getReopenInfo',
    }),

    getReopenInfo() {
      if (this.c_isLogin) {
        this.ma_getReopenInfo();
      }
    },
  },

  created() {
    this.getReopenInfo();
  },
};

const ReopenStepMixin = {
  name: 'ReopenStepMixin',

  data: () => {
    return {
      stepReopenInfo: '',
    };
  },

  computed: {
    c_isStepReopenInfoBlank() {
      return '' === this.stepReopenInfo;
    },
  },

  mounted() {
    $(this.$refs.modalReopenInfo).on('hidden.bs.modal', () => {
      this.stepReopenInfo = '';
    });
  },
};

const ReopenFileMixin = {
  name: 'ReopenFileMixin',

  data: () => {
    return {
      fileReopenInfo: undefined,
    };
  },

  computed: {
    c_isFileReopenInfoEmpty() {
      return undefined === this.fileReopenInfo;
    },

    c_isFileReopenInfoTooLarge() {
      return !this.c_isFileReopenInfoEmpty && this.fileReopenInfo.size > 10 * 1024 * 1024;
    },

    c_isFileReopenInfoReady() {
      return !this.c_isFileReopenInfoEmpty && !this.c_isFileReopenInfoTooLarge;
    },
  },

  methods: {
    triggerFileReopenInfo() {
      this.$refs.fileReopenInfo.click();
    },

    handleChangeFileReopenInfo() {
      this.fileReopenInfo = this.$refs.fileReopenInfo.files[0];
    },
  },
};

// ReopenFileMixin
const ReopenSumbitMixin = {
  name: 'ReopenSumbitMixin',

  data: () => {
    return {
      courseReopenInfo: 'CPA',

      commentReopenInfo: '',
    };
  },

  computed: {
    c_isReopenSubmitDisabled() {
      return !this.c_isFileReopenInfoReady;
    },
  },

  methods: {
    ...mapActions('Dashboard', {
      ma_getReopenInfo: 'getReopenInfo',
      ma_reopenSubmit: 'reopenSubmit',
    }),

    async reopenSubmit() {
      const formData = new FormData();
      formData.append('file', this.fileReopenInfo);
      formData.append('comment', this.commentReopenInfo);
      await this.ma_reopenSubmit(formData);
      this.stepReopenInfo = 'finish';
      this.ma_getReopenInfo();
    },
  },
};

export const ReopenInfoMixin = {
  name: 'ReopenInfoMixin',

  mixins: [GetReopenInfoMixin, ReopenStepMixin, ReopenFileMixin, ReopenSumbitMixin],

  computed: {
    ...mapState('Dashboard', {
      ms_reopenInfo: 'reopenInfo',
      ms_res_reopenSubmit: 'res_reopenSubmit',
    }),

    c_isReopenInProgress() {
      return 0 === this.ms_reopenInfo.requestStatus;
    },
  },
};
